module.exports = __webpack_public_path__ + "img/cooperate_qy_13@2x.b7c6896e.png";